import { useEffect, useState } from 'react';
import _assign from 'lodash/assign';
import useScript from '@/hooks/useScript';
import CONST from '@/utils/Constants/General';

export default ({ wrapperRef, customOptions, readyToRender }) => {
  const [map, setMap] = useState('');
  const [googleMapJSLoaded] = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${DLG.config.googleApiKey}&libraries=places`,
  );
  const defaultMapOptions = {
    center: {
      lat: parseFloat(DLG.config.mapInitialLatitude),
      lng: parseFloat(DLG.config.mapInitialLongitude),
    },
    zoom: CONST.MAPS.Z6,
    zoomControl: true,
    panControl: true,
  };

  const options = _assign(defaultMapOptions, customOptions);

  useEffect(() => {
    if (googleMapJSLoaded && readyToRender) {
      setMap(new google.maps.Map(wrapperRef.current, options));
    }
  }, [googleMapJSLoaded, readyToRender]);

  return [googleMapJSLoaded, map];
};
